import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useNavigate, useParams } from "react-router-dom";

import ProjectHeader from '../../Partials/ProjectHeader';
import ProjectNav from '../../Partials/ProjectNav';
import ButtonSubmit from '../../../../components/Atomes/Buttons/ButtonSubmit';
import ProjectStagePaymentSingleVir from './Virement/PaymentSingleVir';

import { ProjectStageService } from '../../../../services/ProjectStageService';
import ProjectSectionMarketplace from '../../Partials/SectionMarketplace';

const ProjectStagePaymentSingle = () => {

  const navigate = useNavigate();
  const { projectId } = useParams();
  const [projectStepVerificator, setProjectStepVerificator] = useState(false);
  const [project, setProject] = useState(null);
  const [isCbSelected, setIsCbSelected] = useState(false);
  const [isVirSelected, setIsVirSelected] = useState(false);
  const [isWaitingVirValidation, setIsWaitingVirValidation] = useState(false);
  const [invoice, setInvoice] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    getProjectData();
  }, []);

  const getProjectData = async () => {
    let projectInfos = await ProjectStageService.getSingleProject(projectId);
    if ((projectInfos.stage === 'COM_deposit' ||
         projectInfos.stage === 'COM_payment' ||
         projectInfos.stage === 'ADMIN_payment-validation' || 
         projectInfos.stage === 'ADMIN_payment-follow-up') && 
        projectInfos.isSinglePayment === true && !projectInfos.study) {
      projectInfos.invoices.forEach(element => {
        if (element.type === 'bill-invoice-final') {
          if (element.payment?.reference && element.payment?.status === 'processing' && element.payment?.method === "card") {
            return navigate("/projet/" + projectId + "/?event=payment_single_complete", {replace: true})
          }

          if (element.payment) {
            if (element.payment.status === 'paid' && projectInfos.stageStatus !== 'problem') {
              return navigate("/projet/" + projectId + "/?event=payment_single_complete", { replace: true });
            }
          }
          setInvoice(element);
          setTotalAmount(element.amountWithTax);
        }
      });
      
      if (projectInfos.stage === 'ADMIN_payment-validation' && projectInfos.stageStatus === 'processing') {
        setIsWaitingVirValidation(true);
      }
      setProject(projectInfos);
      setProjectStepVerificator(true);
    } else {
      navigate("/projet/" + projectId, { replace: true });
    }
  }

  const handleCbChange = () => {
    setIsCbSelected(!isCbSelected);
    setIsVirSelected(false);
  }

  const handleVirChange = () => {
    setIsVirSelected(!isVirSelected);
    setIsCbSelected(false);
  }

  const handleValidMethod = async () => {
    if (isCbSelected) {
      let redirectUrl = `${process.env.REACT_APP_PROD_URL}/projet/${projectId}/?event=payment_single_complete`;
      let body = {
        "redirectUrl": redirectUrl
      }
      let request = await ProjectStageService.postPayCb(invoice.id, body)
      if (request.status === 201) {
        window.location.replace(request.data.payment.paymentUrl);
      }
    }
  }

  return (
    <>
      {
        !projectStepVerificator ? (
          <>
            <Skeleton height={300} />
            <Skeleton height={40} />
          </>
        ) : (
          <>
            <ProjectHeader
              project={project}
            />

            <section className='project-container'>
              <ProjectNav
                step={2}
                visit={project.visitType}
                paymentType={project.isSinglePayment === true ? 'single' : 'multiple'}
              />
              {
                !isWaitingVirValidation && (
                  <div className="project-container-step__header">
                    <h3 className="color-black">Choisissez votre mode de paiement</h3>
                    <p className="text-primary">
                      Le paiement correspond à 100% du montant du devis que vous avez signé. Une fois votre paiement effectué, vous pourrez passer à l'étape de prise de rendez-vous pour le passage du diagnostiqueur. Dès que votre ingénieur chargé(e) d'affaires aura déposé votre dossier d'étude structure sur votre espace personnel en ligne, vous pourrez accéder directement le télécharger. Par la suite, si vous avez des demandes de modification, vous pouvez les adresser à l'ingénieur chargé(e) d'affaires via le chat interne en bas à droite. Vous pouvez régler par carte bancaire ou par virement bancaire.
                    </p>
                  </div>
                )
              }

              {
                isWaitingVirValidation && (
                  <>
                    <div className="project-container-step__header">
                      <h3 className="color-black">Nous vérifions votre preuve de paiement</h3>
                      <p className="text-primary">
                        Cette étape peut prendre jusqu'à 24 heures. Vous recevrez un e-mail dès que votre paiement sera validé.
                        Vous pourrez ensuite passer à l'étape de prise de rendez-vous avec nos ingénieurs.
                      </p>
                    </div>
                    <ProjectSectionMarketplace />
                  </>
                )
              }

              {
                !isWaitingVirValidation && (
                  <>
                    <div className='project-step-payment__selectMethod'>
                      {project?.invoices?.[0]?.payment?.status === 'error' && (
                        <p className="text-primary color-red" style={{ marginBottom: '10px', fontSize: '16px' }}>
                          Un problème est survenu lors de votre dernier paiement : {project.invoices[0].payment.errorMessage}.
                        </p>
                      )}
                      <h4 className='color-black'>Montant total : {totalAmount} € TTC</h4>
                      <div className={`project-step-choice ${isCbSelected ? 'valid' : ''}`}>
                        <label htmlFor="cb" className='text-tertiary color-dark-grey'>
                          Régler par carte bancaire
                        </label>
                        <input
                          type='radio' id='cb' name="method"
                          onChange={handleCbChange} checked={isCbSelected}
                        />
                      </div>
                      <div className={`project-step-choice ${isVirSelected ? 'valid' : ''}`}>
                        <label htmlFor="vir" className='text-tertiary color-dark-grey'>
                          Régler par virement bancaire
                        </label>
                        <input
                          type='radio' id='vir' name="method"
                          onChange={handleVirChange} checked={isVirSelected}
                        />
                      </div>
                    </div>

                    {
                      isCbSelected && (
                        <div className='project-step-payment__validMethod'>
                          <ButtonSubmit
                            title='Passer au règlement'
                            styleButton='btn-default btn-default-primary'
                            isActive={!isCbSelected && !isVirSelected}
                            onClick={handleValidMethod}
                          />
                        </div>
                      )
                    }

                    {
                      isVirSelected && (
                        <ProjectStagePaymentSingleVir
                          projectInvoice={invoice}
                        />
                      )
                    }

                  </>
                )
              }
            </section>
          </>
        )
      }
    </>
  );
}

export default ProjectStagePaymentSingle;

